import dayjs from 'dayjs'

export const formatDate = (date: Date, format: string = 'YYYY-MM-DD') =>
  dayjs(date).format(format)
export const formatDateTime = (date: Date) =>
  dayjs(date).format('YYYY-MM-DD HH:mm')
export const formatTime = (date: Date) => dayjs(date).format('HH:mm')
export const formatFullDate = (date: Date) =>
  dayjs(date).format('YYYY-MM-DD HH:mm:ss')
export const formatFullDateTime = (date: Date) =>
  dayjs(date).format('YYYY-MM-DD HH:mm:ss')
export const formatFullTime = (date: Date) => dayjs(date).format('HH:mm:ss')
